var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-auto-grow"},[_c('input',{staticClass:"input-auto-grow header-input",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.updateWidth,"blur":_vm.blur}})])
}
var staticRenderFns = []

export { render, staticRenderFns }